import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="image-upload"
export default class extends Controller {
  static targets = ["input", "preview", "upload", "remove", "imageUploadArea", "removeImgField"]

  connect() {
  }

  triggerImageInput(e) {
    this.uploadTarget.click()
  }

  previewImage(event) {
    if(this.hasRemoveImgFieldTarget){
      this.removeImgFieldTarget.value = false
    }
    const input = event.target
    if (input.files && input.files[0]) {
      const reader = new FileReader()

      reader.onload = (e) => {
        this.previewTarget.src = e.target.result
        this.previewTarget.style.display = "block"
        this.previewTarget.classList.remove("d-none")
        this.removeTarget.classList.remove("d-none") // Show the remove icon
        this.imageUploadAreaTarget.classList.add("d-none") // Hide the upload area
      }
      reader.readAsDataURL(input.files[0])
    }
  }

  removeImage() {
    // Clear the file input
    if(this.hasRemoveImgFieldTarget){
      this.removeImgFieldTarget.value = true
    }

    // Hide the image preview and remove icon
    this.previewTarget.classList.add("d-none")
    this.removeTarget.classList.add("d-none")

    // Show the upload area again
    this.imageUploadAreaTarget.classList.remove("d-none")
  }
}
